const drivingtests = {
	title: "Oppkjøringer",
	new_drivingtest: "Ny oppkjøring",
	edit_drivingtest: "Rediger oppkjøring",
	view_drivingtest: "Vis oppkjøring",
	list_title: "Oppkjøringer",
	list_subtitle: "Håndtere oppkjøring",
	create_title: "Opprett oppkjøring",
	update_title: "Endre oppkjøring",
	address_title: "Addresse",
	details_title: "Oppkjøring detaljer",
	id: "ID",
	enrolled_organisation_id: "Organisasjon",
	participant_id: "Deltager",
	coursetypegroup_id: "Kompetanseområde",
	coursetype_id: "Kompetanse",
	course_id: "Kurs",
	description: "Beskrivelse",
	place: "Sted",
	status: "Status",
	instructor_id: "Instruktør",
	class_id: "Klasse",
	date: "Dato",
	time: "Tid",
};
export default drivingtests;